import api from '../config/api';
import { API_URLS } from '../config/urls';

export const blogService = {
    getBlogs: async () => {
        const response = await api.get(API_URLS.BLOGS);
        return response.data;
    },
    getBlogDetail: async (slug) => {
        const response = await api.get(API_URLS.BLOG_DETAIL(slug));
        return response.data;
    },
};
